export default (state: any, {hasError}: any) => ({
  ...state,
  socialMedia: {
    ...state.socialMedia,
    hasError,
  },
});
